import ApiBase from '../ApiBase';

class Groups extends ApiBase {
    route = '/networking/groups';
}

export default new Groups;
